import React from 'react'
import { Chip, ChipProps } from '@mui/material'

import { AcqStatus } from '../../types.ts'
import { EMPTY_VALUE } from '../../constants.ts'

export interface AcqPaymentStatusProps {
  state: AcqStatus
}

const STATUS_TITLES: Record<AcqStatus, string> = {
  ACCEPTED: 'Проведён',
  REGISTERED: 'Зарегистрирован',
  NOT_PAID: 'Не оплачен',
  PAID: 'Оплачен',
  REVERSED: 'Возвращён',
  CANCELED: 'Отменён',
  PARTIAL_REVERSED: 'Частично возвращён',
  HOLD: 'Зарезервирован',
}

const STATUS_COLORS: Record<AcqStatus, ChipProps['color']> = {
  ACCEPTED: 'success',
  REGISTERED: 'info',
  NOT_PAID: 'warning',
  PAID: 'success',
  REVERSED: 'warning',
  PARTIAL_REVERSED: 'warning',
  CANCELED: 'error',
  HOLD: 'warning',
}

export const AcqPaymentStatus = ({ state }: AcqPaymentStatusProps): React.ReactElement =>
  state ? (
    <Chip
      label={STATUS_TITLES[state]}
      color={STATUS_COLORS[state]}
      variant="filled"
      size="small"
      sx={{
        borderRadius: 2,
      }}
    />
  ) : (
    <>{EMPTY_VALUE}</>
  )
